import { z } from 'zod'

export const PublicUser = z.object({
  id: z.string(),
  email: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  username: z.string().nullable(),
  imageUrl: z.string().nullable(),
  bio: z.string().nullable(),
  joined: z.string().nullable(),
  lastAnnouncementReceived: z.string().nullable(),
  lastChangelogSeen: z.string().nullable(),
  showReleaseNote: z.boolean().default(true),
  preferences: z
    .object({
      emailNotifications: z.boolean(),
    })
    .nullish()
    .default({
      emailNotifications: true,
    }),
})

export type PublicUser = z.infer<typeof PublicUser>
